// features/module-master.validation.js

import * as LucideIcons from "lucide-react";

export const moduleMasterValidation = {
  name: (value) => {
    if (!value?.trim()) return "Module name is required";
    if (value.trim().length < 2) return "Module name must be at least 2 characters";
    return "";
  },

  parent_fid: (value, formData) => {
    if (!value) return "";
    if (formData?.id && Number(value) === Number(formData.id)) return "A module cannot be its own parent";
    return "";
  },

  path: (value, formData) => {
    // A parent module has no path field; it's saved with "#".
    if (formData?.is_parent) return "";
    const path = value?.trim();
    if (!path) return "Path is required";
    if (!path.startsWith("/")) return "Path must start with /";
    return "";
  },

  icon: (value) => {
    const icon = value?.trim();
    if (!icon) return "";
    if (!LucideIcons[icon]) return "Unknown icon. Use a lucide-react icon name, e.g. LayoutDashboard";
    return "";
  },

  badge: () => "",
};
